import { Routes, Route, Outlet } from 'react-router-dom';
import { UniformMgmtProvider } from '../context/uniformMgmtContext';

import MastersDashboard from '../masters/MastersDashboard';
import UniformItemDetail from '../masters/items/UniformItemDetail';
import WarehouseDetail from '../masters/warehouses/WarehouseDetail';

import TransferList from '../inventory/transfers/TransferList';
import StockTakeList from '../inventory/stockTake/StockTakeList';
import StockTakeDetail from '../inventory/stockTake/StockTakeDetail';
import POList from '../inventory/purchaseOrders/POList';
import PODetail from '../inventory/purchaseOrders/PODetail';

import IssuanceList from '../issuance/issuanceList/IssuanceList';
import IssuanceDetail from '../issuance/issuanceDetail/IssuanceDetail';
import IssuanceBatchDetail from '../issuance/batchDetail/IssuanceBatchDetail';
import BulkIssuance from '../issuance/bulkIssuance/BulkIssuance';
import RejectionReview from '../issuance/rejectionReview/RejectionReview';

import EmployeeUniformCard from '../employee/uniformCard/EmployeeUniformCard';
import MyUniformsList from '../employee/myUniforms/MyUniformsList';

import ReportsDashboard from '../reports/ReportsDashboard';

function UniformMgmtRouter() {
  return (
    <UniformMgmtProvider>
      <Routes>
        <Route path="/" element={<Outlet />}>
          <Route index element={<MastersDashboard />} />
          <Route path="items/:id" element={<UniformItemDetail />} />
          <Route path="warehouses/:id" element={<WarehouseDetail />} />

          <Route path="purchase-orders" element={<POList />} />
          <Route path="purchase-orders/:id" element={<PODetail />} />
          <Route path="transfers" element={<TransferList />} />
          <Route path="stock-take" element={<StockTakeList />} />
          <Route path="stock-take/:id" element={<StockTakeDetail />} />

          <Route path="issuance" element={<IssuanceList />} />
          <Route path="issuance/batches/:id" element={<IssuanceBatchDetail />} />
          <Route path="issuance/:id" element={<IssuanceDetail />} />
          <Route path="bulk-issuance" element={<BulkIssuance />} />
          <Route path="rejection-review" element={<RejectionReview />} />

          <Route path="employee-card/:userId" element={<EmployeeUniformCard />} />
          <Route path="my-uniforms" element={<MyUniformsList />} />

          <Route path="reports" element={<ReportsDashboard />} />
        </Route>
      </Routes>
    </UniformMgmtProvider>
  );
}

export default UniformMgmtRouter;
